import { render, staticRenderFns } from "./assistant_main.vue?vue&type=template&id=5e02bd78&scoped=true&"
import script from "./assistant_main.vue?vue&type=script&lang=js&"
export * from "./assistant_main.vue?vue&type=script&lang=js&"
import style0 from "./assistant_main.vue?vue&type=style&index=0&id=5e02bd78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02bd78",
  null
  
)

export default component.exports